//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  cloneDeep,
  dig,
} from '@/utils/lodash'

export default {
  components: {},

  props: {
    data: {
      type: Array,
      default: () => ([]),
    },

    column: {
      type: Array,
      default: () => ([]),
    },

    apiMethod: { type: Function },

    params: {
      type: Object,
      default: () => ({}),
    },

    dataHook: { type: Function },

    dataPath: {
      type: String,
      default: 'data',
    },
  },

  data () {
    return { innerList: [] }
  },

  computed: {},

  watch: {
    data: {
      handler (val) {
        if (val && !this.apiMethod) {
          this.innerList = cloneDeep(this.data)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async created () {
    if (this.apiMethod) {
      const data = await this.apiMethod(this.params)
      const result = dig(data, this.dataPath) || []
      this.innerList = this.dataHook ? this.dataHook(result) : result
    }
  },

}
